import { UserConfig } from "@/model/data/authentication/UserConfig";

export class UpdateCurrentUserReqData {
    email: string;
    userConfig: UserConfig;
}
